import * as Api from '../../../api/Api';
import { useState } from 'react';
import PermissionsGate from '../../../api/PermissionsGate';
import { SCOPES } from '../../../config/permissions-map';
import { Unauthorized } from '../../Global/unauthorized';
import AgTable from '../../../Components/Table/AgTable';
import { useGetToken } from '../../../Hooks/CustomHooks';
import * as Utilities from '../../../Components/Utils/Utils';
import { PageTitle } from '../../../../_metronic/layout/core';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import SelectList from '../../../Components/Select/SelectList';

export default function ListaRoja({ title }) {
    const token = useGetToken();
    let header = [
        {
            headerName: 'Malls',
            field: 'unidadEconomica',
        },
        {
            headerName: 'Código Contrato',
            field: 'codContrato',
        },
        {
            headerName: 'Nombre Contrato',
            field: 'nombreContrato',
        },
        {
            headerName: 'Fecha Último Registro',
            field: 'fechaUltimoRegistro',
        },
        {
            headerName: 'Dias faltantes al cierre',
            field: 'diasFaltantesCierre',
            type: 'rightAligned',
        }
    ];

    const animatedComponents = makeAnimated();
    const [unidadEconomica, setUnidadEconomica] = useState(Utilities.getListUnidadesEconomicas().list[0]);
    const [cebe, setCebe] = useState(null)
    const [searchCebe, setSearchCebe] = useState(false)
    const [codigoContrato, setCodigoContrato] = useState(null);
    let unidadesEconomicasList = Utilities.getListUnidadesEconomicas();

    const getOptionValueUnidEconomica = idDefault => {
        return unidadesEconomicasList.list.filter(obj => obj.value === idDefault)
    }
    const onChangeUnidadEconomica = (inputValue) => {
        setUnidadEconomica(inputValue);
    }
    const onChangeCebe = (inputValue) => {
        setCebe(inputValue);
    }

    const [auxData, setAuxData] = useState(
        {
            "fechaCumplimiento": null,
            "cumplimiento": {
                "locatariosFaltantes": {
                    "arequipa": null,
                    "santaAnita": null,
                    "chiclayo": null
                },
                "locatariosCumplidos": {
                    "arequipa": null,
                    "santaAnita": null,
                    "chiclayo": null
                },
                "porcentajeCumplimiento": {
                    "arequipa": null,
                    "santaAnita": null,
                    "chiclayo": null
                },
                "locatariosTotales": null,
                "porcentajeCumplimientoTotal": null
            }
        }
    );

    function handleChangeCodigoContrato(event) {
        if (event.key === 'Enter') {
            setCodigoContrato(event.target.value);
        }
    }

    const styleCard = {
        backgroundImage: `url(../media/svg/shapes/abstract-4.svg)`,
        backgroundSize: "cover",
        backgroundPosition: "right top",
        backgroundSize: "30% auto"
    }


    return (
        <>
            <PermissionsGate RenderError={() => <Unauthorized />} scopes={[SCOPES.LISTA_ROJA]} >
                <PageTitle>{title}</PageTitle>
                <div className='d-flex flex-row-reverse mb-6'>
                    <div className="fs-6 text-dark">
                        <span className="">Fecha del reporte:  </span>
                        <span className="">{auxData.fechaCumplimiento}</span>
                    </div>
                </div>

                <div className="card-body py-3">
                    <h3 className="fw-bolder mb-6">Locatarios Faltantes</h3>
                    <div className="row g-5 g-xl-8">
                        <div className="col-sm-6 col-md-3 col-xl-2">
                            <div className="card ">
                                <div className="card-body">
                                    <div className="d-flex text-center flex-column text-dark pt-2">
                                        <span className="fw-bold fs-7">Mall Arequipa</span>
                                        <div className="d-flex align-items-center justify-content-center pt-2">
                                            <span className="fw-bolder fs-2x pt-1">{auxData.cumplimiento.locatariosFaltantes.arequipa}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-3 col-xl-2">
                            <div className="card ">
                                <div className="card-body">
                                    <div className="d-flex text-center flex-column text-dark pt-2">
                                        <span className="fw-bold fs-7">Mall Santa Anita</span>
                                        <div className="d-flex align-items-center justify-content-center pt-2">
                                            <span className="fw-bolder fs-2x pt-1">{auxData.cumplimiento.locatariosFaltantes.santaAnita}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-3 col-xl-2">
                            <div className="card ">
                                <div className="card-body">
                                    <div className="d-flex text-center flex-column text-dark pt-2">
                                        <span className="fw-bold fs-7">Mall Chiclayo</span>
                                        <div className="d-flex align-items-center justify-content-center pt-2">
                                            <span className="fw-bolder fs-2x pt-1">{auxData.cumplimiento.locatariosFaltantes.chiclayo}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-3 col-xl-2">
                            <div className="card ">
                                <div className="card-body">
                                    <div className="d-flex text-center flex-column text-dark pt-2">
                                        <span className="fw-bold fs-7">Mall Iquitos</span>
                                        <div className="d-flex align-items-center justify-content-center pt-2">
                                            <span className="fw-bolder fs-2x pt-1">{auxData.cumplimiento.locatariosFaltantes.iquitos}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-3 col-xl-2">
                            <div className="card ">
                                <div className="card-body">
                                    <div className="d-flex text-center flex-column text-dark pt-2">
                                        <span className="fw-bold fs-7">Mall San Juan de Lurigancho</span>
                                        <div className="d-flex align-items-center justify-content-center pt-2">
                                            <span className="fw-bolder fs-2x pt-1">{auxData.cumplimiento.locatariosFaltantes.sjl}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="mb-5 mb-xl-8">
                    <div className="card-body py-3">
                        <h3 className="fw-bolder mb-6 mt-6">Locatarios Cumplidos</h3>
                        <div className="row g-5 g-xl-8">
                            <div className="col-sm-6 col-md-3 col-xl-2">
                                <div className="card ">
                                    <div className="card-body">
                                        <div className="d-flex text-center flex-column text-dark pt-2">
                                            <span className="fw-bold fs-7">Mall Arequipa</span>
                                            <div className="d-flex align-items-center justify-content-center pt-2">
                                                <span className="fw-bolder fs-2x pt-1">{auxData.cumplimiento.locatariosCumplidos.arequipa}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-3 col-xl-2">
                                <div className="card ">
                                    <div className="card-body">
                                        <div className="d-flex text-center flex-column text-dark pt-2">
                                            <span className="fw-bold fs-7">Mall Santa Anita</span>
                                            <div className="d-flex align-items-center justify-content-center pt-2">
                                                <span className="fw-bolder fs-2x pt-1">{auxData.cumplimiento.locatariosCumplidos.santaAnita}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-3 col-xl-2">
                                <div className="card ">
                                    <div className="card-body">
                                        <div className="d-flex text-center flex-column text-dark pt-2">
                                            <span className="fw-bold fs-7">Mall Chiclayo</span>
                                            <div className="d-flex align-items-center justify-content-center pt-2">
                                                <span className="fw-bolder fs-2x pt-1">{auxData.cumplimiento.locatariosCumplidos.chiclayo}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-3 col-xl-2">
                                <div className="card ">
                                    <div className="card-body">
                                        <div className="d-flex text-center flex-column text-dark pt-2">
                                            <span className="fw-bold fs-7">Mall Iquitos</span>
                                            <div className="d-flex align-items-center justify-content-center pt-2">
                                                <span className="fw-bolder fs-2x pt-1">{auxData.cumplimiento.locatariosCumplidos.iquitos}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-3 col-xl-2">
                                <div className="card ">
                                    <div className="card-body">
                                        <div className="d-flex text-center flex-column text-dark pt-2">
                                            <span className="fw-bold fs-7">Mall San Juan de Lurigancho</span>
                                            <div className="d-flex align-items-center justify-content-center pt-2">
                                                <span className="fw-bolder fs-2x pt-1">{auxData.cumplimiento.locatariosCumplidos.sjl}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>


                </div>
                <div className="mb-5 mb-xl-8">
                    <div className="card-body py-3">
                        <h3 className="fw-bolder mb-6 mt-6">Porcentaje Cumplimiento</h3>

                        <div className="row g-5 g-xl-8">
                            <div className="col-sm-6 col-md-3 col-xl-2">
                                <div className="card ">
                                    <div className="card-body">
                                        <div className="d-flex text-center flex-column text-dark pt-2">
                                            <span className="fw-bold fs-7">Mall Arequipa</span>
                                            <div className="d-flex align-items-center justify-content-center pt-2">
                                                <span className="fw-bolder fs-2x pt-1">{Utilities.comillasFix(auxData.cumplimiento.porcentajeCumplimiento.arequipa, true, 1)}%</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-3 col-xl-2">
                                <div className="card ">
                                    <div className="card-body">
                                        <div className="d-flex text-center flex-column text-dark pt-2">
                                            <span className="fw-bold fs-7">Mall Santa Anita</span>
                                            <div className="d-flex align-items-center justify-content-center pt-2">
                                                <span className="fw-bolder fs-2x pt-1">{Utilities.comillasFix(auxData.cumplimiento.porcentajeCumplimiento.santaAnita, true, 1)}%</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-3 col-xl-2">
                                <div className="card ">
                                    <div className="card-body">
                                        <div className="d-flex text-center flex-column text-dark pt-2">
                                            <span className="fw-bold fs-7">Mall Chiclayo</span>
                                            <div className="d-flex align-items-center justify-content-center pt-2">
                                                <span className="fw-bolder fs-2x pt-1">{Utilities.comillasFix(auxData.cumplimiento.porcentajeCumplimiento.chiclayo, true, 1)}%</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-3 col-xl-2">
                                <div className="card ">
                                    <div className="card-body">
                                        <div className="d-flex text-center flex-column text-dark pt-2">
                                            <span className="fw-bold fs-7">Mall Iquitos</span>
                                            <div className="d-flex align-items-center justify-content-center pt-2">
                                                <span className="fw-bolder fs-2x pt-1">{Utilities.comillasFix(auxData.cumplimiento.porcentajeCumplimiento.iquitos, true, 1)}%</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-3 col-xl-2">
                                <div className="card ">
                                    <div className="card-body">
                                        <div className="d-flex text-center flex-column text-dark pt-2">
                                            <span className="fw-bold fs-7">San Juan de Lurigancho</span>
                                            <div className="d-flex align-items-center justify-content-center pt-2">
                                                <span className="fw-bolder fs-2x pt-1">{Utilities.comillasFix(auxData.cumplimiento.porcentajeCumplimiento.sjl, true, 1)}%</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-6">
                                <div className="card bg-danger-mall">
                                    <div className="card-body">
                                        <div className="d-flex text-center flex-column text-red-mall pt-2">
                                            <span className="fw-bold fs-7">Locatarios Totales</span>
                                            <div className="d-flex align-items-center justify-content-center pt-2">
                                                <span className="fw-bolder fs-2x pt-1">{auxData.cumplimiento.locatariosTotales}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-6">
                                <div className="card bg-light-blue">
                                    <div className="card-body">
                                        <div className="d-flex text-center flex-column text-blue pt-2">
                                            <span className="fw-bold fs-7">Porcentaje Cumplimiento Total</span>
                                            <div className="d-flex align-items-center justify-content-center pt-2">
                                                <span className="fw-bolder fs-2x pt-1">{Utilities.comillasFix(auxData.cumplimiento.porcentajeCumplimientoTotal, true, 1)}%</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card my-5">
                    <div className="card-header border-0 pt-6 row g-3 flex-wrap d-flex flex-row">
                        <div className="col-12 col-sm-4">
                            <div className="fw-bold fs-7 text-gray-600 mb-1">Mall:</div>
                            <Select
                                classNamePrefix='filter'
                                components={animatedComponents}
                                defaultValue={getOptionValueUnidEconomica(unidadesEconomicasList.defaultId)}
                                isMulti={false}
                                closeMenuOnSelect={true}
                                options={unidadesEconomicasList.list}
                                onChange={onChangeUnidadEconomica}
                            />
                        </div>
                        <div className="col-12 col-sm-4">
                            <div className="fw-bold fs-7 text-gray-600 mb-1">CeBe:</div>
                            <SelectList
                                classNamePrefix='filter'
                                apiService={Api.ListaCebe}
                                args={{ token: useGetToken(), unidadEconomicaId: unidadEconomica.value }}
                                conditions={true || searchCebe}
                                setConditions={setSearchCebe}
                                handleChange={onChangeCebe}
                                multiple={false}
                                defaultSetterFunction={setCebe}
                            />
                        </div>
                        <div className="col-12 col-sm-4" >
                            <div className="fw-bold fs-7 text-gray-600 mb-1">Código Contrato:</div>
                            <input type="text" name="name" className="form-control"
                                onKeyDown={handleChangeCodigoContrato} />
                        </div>
                    </div>
                    <div className='card-body'></div>
                </div>


                <div className="card my-5">
                    <div className="card-body tab-content">
                        {cebe &&
                            <AgTable
                                idContent={"ListaRoja" + unidadEconomica.value + codigoContrato + cebe.label}
                                apiService={Api.ListaRoja}
                                setAuxData={setAuxData}
                                header={header}
                                titleExcel={"Lista Roja " + unidadEconomica.label + " " + codigoContrato}
                                conditions={true}
                                args={{ unidadEconomicaId: unidadEconomica.value, cebe: (cebe?.value) ? cebe.value : null, codigoContratoId: codigoContrato, token: token }}
                                hideFilter={false}
                                paginationPageSize={8}
                                rowHeight={40}
                                useFlex = {false}
                            />
                        }
                    </div>
                </div>
            </PermissionsGate>
        </>
    )
}